import React from 'react';
import styled from 'styled-components';

import {
  organizationIcons,
  organizationKeyEnum,
  organizationLabels,
} from './profileLinkEnums';

const Wrap = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const ChildWrap = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: left;
`;

const Item = ({ children, isSelected }) => {
  return (
    <Wrap key={children} isSelected={isSelected}>
      <ChildWrap>{children}</ChildWrap>
    </Wrap>
  );
};

const getOrganizationText = (text, orgKey, node) => {
  const { data } = node;
  const organizationTextString = data.get('organizationText');
  const organizationText = organizationTextString
    ? JSON.parse(organizationTextString)
    : {};
  return organizationText[orgKey] || text;
};

const baseKeys = [
  organizationKeyEnum.OTHERS,
  organizationKeyEnum.LINKEDIN,
  organizationKeyEnum.GITHUB,
  organizationKeyEnum.TWITTER,
  organizationKeyEnum.FACEBOOK,
  organizationKeyEnum.DRIBBLE,
  organizationKeyEnum.BEHANCE,
  organizationKeyEnum.MEDIUM,
  organizationKeyEnum.KAGGLE,
  organizationKeyEnum.RESEARCHGATE,
  organizationKeyEnum.GOOGLESCHOLAR,
  organizationKeyEnum.STACKOVERFLOW,
  organizationKeyEnum.ANGELLIST,
  organizationKeyEnum.YOUTUBE,
  organizationKeyEnum.CODEPEN,
  organizationKeyEnum.VSCO,
  organizationKeyEnum.INSTAGRAM,
  organizationKeyEnum.GOODREADS,
];

export default (params) => {
  const { updateButton, node } = params;

  const isSelected = (orgKey) => {
    const { data } = node;
    const organization = data.get('organization');
    return organization === orgKey;
  };

  const createItem = (orgKey) => {
    const displayText = organizationLabels[orgKey] || orgKey;
    return {
      type: 'personalLinks',
      startIcon: organizationIcons[orgKey],
      item: (
        <Item orgKey={orgKey} isSelected={isSelected(orgKey)}>
          {getOrganizationText(displayText, orgKey, node)}
        </Item>
      ),
      dataTestId: `menu_items_${orgKey}`,
      triggerFunction: () => updateButton(orgKey),
      isHighlighted: isSelected(orgKey),
    };
  };

  const itemsList = baseKeys.map(createItem);

  return itemsList;
};
